import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import "./index.css";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import SignUp from "./pages/SignUp";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import MyNumbers from "./pages/MyNumber";
import Transactions from "./pages/Transactions";
import Community from "./pages/Community";
import BuyNumbers from "./pages/BuyNumbers";
import AddMoney from "./pages/AddMoney";
import ChatUs from "./pages/ChatUs";
import Settings from "./pages/Settings";
import LoginPage from "./pages/Login";
import VerifyEmail from "./pages/VeirifyEmail";
import VerifyNotice from "./pages/VerifyNoticePage";
import PaymentSuccess from "./pages/PaymentSuccess";
import SmsOrder from "./pages/SmsOrder";
import SmsHome from "./pages/SmsHome";
import UsBuyNumber from "./pages/UsBuyNumber";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfServices from "./pages/TermsOfServices";

//
import Admin from "./pages/Admin";
import AdminPercentage from "./pages/AddminPercentage";

//
import Dashboard from "./pages/Dashbaord";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/About" element={<About />} />
        <Route path="/Services" element={<Services />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/SignUp" element={<SignUp />} />
        <Route path="/Login" element={<LoginPage />} />
        <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/TermsOfServices" element={<TermsOfServices />} />
        <Route path="/ForgotPassword" element={<ForgotPassword />} />
        <Route path="/resetpassword/:token" element={<ResetPassword />} />
        <Route path="/Dashboard" element={<Dashboard />} />
        <Route path="/dashboard/numbers" element={<MyNumbers />} />
        <Route path="/dashboard/transactions" element={<Transactions />} />
        <Route path="/dashboard/community" element={<Community />} />
        <Route path="/dashboard/Recieve/Global/SMS" element={<BuyNumbers />} />
        <Route path="/dashboard/Recieve/US/SMS" element={<UsBuyNumber />} />
        <Route path="/dashboard/add/money" element={<AddMoney />} />
        <Route path="/dashboard/BuySmsRoutePage" element={<SmsHome />} />
        <Route path="/dashboard/chat" element={<ChatUs />} />
        <Route path="/dashboard/settings" element={<Settings />} />
        <Route path="/VerifyNoticePage" element={<VerifyNotice />} />
        <Route path="/verify/:token" element={<VerifyEmail />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/dashboard/SmsOrder" element={<SmsOrder />} />
        {/*  */}
        <Route path="/admin/dashboard" element={<Admin />} />
        <Route path="/Admin/Percentage" element={<AdminPercentage />} />
      </Routes>
    </Router>
  );
}

export default App;
